module.exports = __webpack_public_path__ + "img/employee.5e33da9b.png";